<div class="ero">
    <div class="eroInputs">
        <span class="eroTitle">Charge Details (The below charges are added and pushed to Arthakosh)</span>
        <!--        <i class="flaticon-close" matTooltip="Close" matTooltipPosition="left" (click)="cancelChargesDialog()"></i>-->
    </div>
    <mat-dialog-content style="flex-direction: column">
        <ng-container>
            <mat-table [dataSource]="chargesDataSource" class="setTable" style="    max-height: 50dvh;
    overflow: auto;">
                <ng-container [matColumnDef]="'charge_description'">
                    <mat-header-cell *matHeaderCellDef> Charge</mat-header-cell>
                    <mat-cell *matCellDef="let data" class="fs-12 ">
                        <div style="display: flex; flex-direction: column; align-items:
                                                        flex-start;">
                            <span class="natureChip">
                                {{data.charge_description}}
                            </span>
                        </div>
                    </mat-cell>
                </ng-container>
                <ng-container [matColumnDef]="'requirement'">
                    <mat-header-cell *matHeaderCellDef> Requirement</mat-header-cell>
                    <mat-cell *matCellDef="let data" class="fs-12 ">
                        <div style="display: flex; flex-direction: column; align-items:
                                                        flex-start;">
                        <span class="natureChip">
                            {{data.particulars}}
                        </span>
                        </div>
                    </mat-cell>
                </ng-container>
                <ng-container [matColumnDef]="'quantity'">
                    <mat-header-cell *matHeaderCellDef> Quantity</mat-header-cell>
                    <mat-cell *matCellDef="let data" class="fs-12 ">
                    <span>
                        {{data.quantity}}
                    </span>
                    </mat-cell>
                </ng-container>
                <ng-container [matColumnDef]="'amount_per_unit'">
                    <mat-header-cell *matHeaderCellDef> Amount/Unit</mat-header-cell>
                    <mat-cell *matCellDef="let data" class="fs-12 overflow-visible" [class.p-r-15]="data.edit">
                    <span>
                        {{data.amount_per_unit | number: '1.2-2'}} {{data.currency}}
                    </span>
                    </mat-cell>
                </ng-container>
                <ng-container [matColumnDef]="'total_amount'">
                    <mat-header-cell *matHeaderCellDef> Total</mat-header-cell>
                    <mat-cell *matCellDef="let data" class="fs-12 ">
                        <span>
                            {{data.total_amount | number: '1.2-2'}} {{data.currency}}
                        </span>
                    </mat-cell>
                </ng-container>
                <mat-header-row
                        *matHeaderRowDef="displayedColumnsCharges ; sticky: true "></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumnsCharges;"></mat-row>
            </mat-table>
            <ng-container *ngIf="!chargesDataSource?.data?.length">
                <div class="noData" (mousemove)="onMouseMove($event)">
                    <h1 #title>No Data Found</h1>
                </div>
            </ng-container>
            <!--            <mat-paginator [pageSizeOptions]="[5, 10, 25]" aria-label="Select page of users"-->
            <!--                           [pageSize]="10"-->
            <!--                           [length]="pageLength"-->
            <!--                           #paginator></mat-paginator>-->
        </ng-container>
        <mat-dialog-actions style="justify-content: center;    min-height: fit-content;    padding-bottom: 5px;">
            <!--            <button mat-raised-button class="Cancel" (click)="cancelChargesDialog()">Close</button>-->
            <button mat-raised-button (click)="cancelChargesDialog()" class="Save " (mouseover)="set = true"
                    (mouseout)="set = false">
                Ok
            </button>
        </mat-dialog-actions>
    </mat-dialog-content>
</div>
<!-- <div class="bg" [class.set]="set"></div> -->
